<template>
  <div>
    <div class="columns">
      <div class="column is-1"></div>
      <!-- Overview Mode -->

      <div
        class="column is-10"
        v-if="action == 'projectOverview' || action == 'subcomponentOverview'"
      >
        <div class="card">
          <div class="card-content">
            <div class="media">
              <!-- <div class="media-left" v-if="itemPic != ''">
                <figure class="image is-128x128">
                  <img :src="imageLink" alt="Thumbnail" />
                </figure>
              </div> -->
              <div class="media-content">
                <p class="title is-4">Title: {{ formData.dct_title }}</p>
                <p class="subtitle is-6">
                  Description: {{ formData.dct_description }}
                </p>

                <p
                  class="subtitle is-6"
                  v-if="getStatistics.annotatedSpeciesCount"
                >
                  Annotated Species count:
                  {{ getStatistics.annotatedSpeciesCount }}
                </p>
              </div>
            </div>

            <div class="content" v-if="action == 'projectOverview'">
              <nav class="level">
                <p class="level-item has-text-centered">
                  <router-link :to="routerlink">
                    <o-button
                      variant="info"
                      outlined
                      style="width: 100%"
                      class="is-size-6"
                      >Click here for more</o-button
                    ></router-link
                  >
                </p>
              </nav>
            </div>

            <b v-if="action == 'subcomponentOverview'">
              <router-link :to="routerlink">
                <a>Click here for more</a></router-link
              ></b
            >
          </div>
        </div>
      </div>

      <!-- Create or Edit Mode -->
      <div class="column is-10" v-if="action == 'create' || action == 'edit'">
        <!-- Step 1: Primary informations -->
        <!-- Debug:<br />
            action: {{ action }}<br /> -->

        <o-field label="Note:" variant="warning" v-if="action === 'create'">
          After you have created a project, you can create new station
          layouts<br /><br
        /></o-field>

        <o-field label="Project title" message="*required" variant="">
          <o-input v-model="formData.dct_title"></o-input>
        </o-field>

        <o-field label="Project description" message="*required" variant="">
          <o-input v-model="formData.dct_description"></o-input>
        </o-field>

        <!-- Buttons -->
        <br />
        <div class="columns">
          <div class="column"></div>

          <div class="column is-1">
            <o-button
              icon-left="plus"
              variant="primary"
              iconPack="fa"
              @click.prevent="handleObject"
            >
              {{ action === "create" ? "Create" : "" }}
              {{ action === "edit" ? "Update" : "" }}
            </o-button>
          </div>
          <div class="column is-2"></div>
          <div class="column is-1">
            <o-button
              icon-left="ban"
              variant="warning"
              iconPack="fa"
              @click.prevent="stepBack"
            >
              Cancel
            </o-button>
          </div>
          <div class="column"></div>
        </div>

        <!-- Step 2: Station Layouts -->
        <br />
        <div v-if="action == 'edit'">
          <div class="has-text-weight-semibold">Station layouts overview</div>
          <br />
          <o-field label="Note:" variant="warning" v-if="action === 'create'">
            After you have created a station layout, you can create new station
            setups.<br /><br
          /></o-field>

          <section style="width: 100%">
            <div
              v-for="item in formData.ods_hasStationsLayouts"
              :key="item"
              class="box"
            >
              <!-- item {{ item }} key {{ key }} -->
              <StationsLayout :action="'projectView'" :stationLayoutID="item" />
            </div>
          </section>

          <!-- Create a new station layout here -->
          <br />
          <section style="width: 100%" v-if="stationLayoutsNewOne == true">
            <div class="box">
              <StationsLayout :action="'create'" :projectID="objectID" />
            </div>
          </section>

          <br />
          <o-button
            icon-left="plus"
            variant="primary"
            iconPack="fa"
            @click.prevent="stationLayoutsNewOne = !stationLayoutsNewOne"
            v-if="stationLayoutsNewOne == false"
          >
            Add new station layout
          </o-button>
        </div>
      </div>
      <div class="column is-1"></div>
    </div>
  </div>
</template>

<script setup>
import StationsLayout from "@/components/forms/StationLayoutForm.vue";
</script>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

import CordraMixin from "@/mixins/cordra";
import CamAndCaptureMixin from "@/mixins/camAndCapture";

export default {
  name: "ProjectForm",
  mixins: [CordraMixin, CamAndCaptureMixin],
  props: [
    "action" /* action is 'create', 'edit', 'projectOverview', 'subcomponentOverview' */,
    "objectID",
  ],

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      routerlink: "/projects/" + this.objectID,

      formData: {
        dct_title: "",
        dct_description: "",
        ods_hasStationsLayouts: [],
      },
      stationLayoutsNewOne: false,
    };
  },

  methods: {
    ...mapMutations({ newMessage: "messenger/newMessage" }),

    async createCordraObject() {
      // console.group("createCordraObject");
      var error = this.validateForm();
      if (error) {
        return false;
      }

      let cordraObject = {
        type: process.env.VUE_APP_CORDRA_DATATYPE_PROJECT,
        content: {
          name: this.formData.dct_title,
          description: this.formData.dct_description,
          hasStationsLayouts: [],
        },
      };
      // console.groupEnd();

      this.stepBack(await this.cordraCreateDocument(cordraObject));
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async updateCordraObject() {
      // console.group("Project updateCordraObject");
      var error = this.validateForm();
      if (error) {
        // console.log("Check form, result: error");

        return false;
      }
      // console.log("Check form, resilt: OK");

      let cordraProjectObject = {
        id: this.objectID,
        content: {
          id: this.objectID,
          name: this.formData.dct_title,
          description: this.formData.dct_description,
          hasStationsLayouts: this.formData.ods_hasStationsLayouts,
          "@context": this.formData.context,
        },
      };

      // console.log("ready, send object to cordra");
      // console.groupEnd();

      this.stepBack(await this.cordraUpdateDocument(cordraProjectObject));
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    validateForm() {
      // console.group("Project validateForm");
      var error = false;

      var createError = (msg) => {
        let message = {
          content: "An error has occurred: " + msg,
          kind: "danger",
        };
        this.newMessage(message);
      };

      if (this.formData.dct_title === "") {
        error = true;
        createError("Please insert a title for this project.");
      } else if (this.formData.dct_title.length < 3) {
        error = true;
        createError(
          "Please insert a title for this project and use minimum 3 characters."
        );
      }

      if (this.formData.dct_description === "") {
        error = true;
        createError("Please insert a description for this project.");
      } else if (this.formData.dct_description.length < 3) {
        error = true;
        createError(
          "Please insert a description for this project and use minimum 3 characters."
        );
      }
      // console.log("result:", error);
      // console.groupEnd();
      return error;
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stepBack(resultFlag = {}) {
      // TODO: check resultFlag error cases
      console.group("stepBack, resultFlag:", resultFlag);

      if (resultFlag === false) {
        console.warn("error in stepBack()");
      } else if (this.action === "create") {
        this.editDataset("projects", resultFlag.id);
      } else if (this.action === "edit") {
        this.$router.push(`/projects/${this.objectID}`);
      }

      console.groupEnd();
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    restoreData() {
      console.group("restoreData");

      const firstResult = this.cordraSearchResult[0];
      this.formData.dct_title = firstResult.content["name"];
      this.formData.dct_description = firstResult.content["description"];

      this.formData.ods_hasStationsLayouts =
        firstResult.content["hasStationsLayouts"];

      this.formData.context = firstResult.content["@context"];

      this.formData.projectStatistics = firstResult.content.projectStatistics;

      console.log("this.formData", this.formData);
      console.groupEnd();
    },
  },

  computed: {
    ...mapGetters({
      keycloakGetStatusReady: "keycloak/getStatusReady",
      keycloakGetStatusAuthenticated: "keycloak/getStatusAuthenticated",
    }),

    getStatistics() {
      if (this.formData.projectStatistics) {
        return {
          annotatedSpeciesCount:
            this.formData.projectStatistics.annotatedSpeciesCount,
        };
      }
      return { annotatedSpeciesCount: false };
    },
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  created() {
    if (
      this.action === "edit" ||
      this.action == "projectOverview" ||
      this.action == "subcomponentOverview"
    ) {
      this.cordraGetDocumentAndOwnership(this.objectID);
    }
  },

  // async created() {
  // if (this.$keycloak_token) {
  //   const payloadBlob = await this.cordraCreateTemporaryClient().getPayload(
  //     this.itemID,
  //     this.itemPic
  //   );
  //   const objectUrl = URL.createObjectURL(payloadBlob);
  //   this.imageLink = objectUrl;
  // } else {
  //   this.imageLink = this.cordraGetPublicPayloadLink(
  //     this.itemID,
  //     this.itemPic
  //   );
  // }
  // },
};
</script>
